import { integrationSlugs } from '@global/constants'
import type { ApiResponseTemplate, Integration } from '@templates/types'

export const findIntegrationBySlug = (
  slug: string,
  integrations?: Integration[],
): Integration | undefined => integrations?.find(item => item.slug === slug)

export const findIntegrationIdBySlug = (
  integrations: Integration[],
  slug: string,
): number | undefined => {
  return findIntegrationBySlug(slug, integrations)?.id
}

export const getIsMetaIntegration = (template: ApiResponseTemplate): boolean => {
  return !!findIntegrationBySlug(integrationSlugs.FACEBOOK_MARKETING_INBOUND, template.integrations)
}
